module.exports = __webpack_public_path__ + "img/valencia.fe82c4d0.png";